import React from 'react';
import { NavLink } from 'react-router-dom';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';
// Selectors
import { selectSystemMessages } from 'app/store/AppUINotifications/AppUINotifications.selectors';
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Alert, Box } from '@mui/material';
// Icons
import { Close as CloseIcon } from '@mui/icons-material';
// Components
import { Button, IconButton } from 'app/components/Mui';

const SystemNotifications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const myUser:any = useSelector(selectMyUser);
  const messages:any[] = useSelector(selectSystemMessages);

  const [ selectedMessage, setSelectedMessage ] = React.useState<any>(null);

  React.useEffect(() => {
    setSelectedMessage(messages.length ? messages[0] : null);
    // eslint-disable-next-line
  }, [messages]);

  const handleCloseMessage = () => {
    if ( selectedMessage ) dispatch(AppUiNotificationsActions.removeSystemMessage(selectedMessage.id));
  }

  const renderActionButton = () => {
    const { actionButton } = selectedMessage;
    if (!actionButton) return null;

    const label = actionButton.label ?? t('buttons.open');

    const onClick = () => {
      if (actionButton.onClick) actionButton.onClick();
      handleCloseMessage();
    };

    return (
      <Button
        name={`Action button ${label}`}
        size="small"
        onClick={onClick}
        component={actionButton.to ? NavLink : 'button'}
        to={actionButton.to}
        sx={{ textDecoration: 'none !important', p: 0 }}
      >
        {label}
      </Button>
    );
  };

  if ( !messages.length || !selectedMessage ) return null;
  const shouldShow = selectedMessage.forceShow || (myUser && myUser.notificationPreferences.push);
  if (!shouldShow) return null;
  return (
    <Alert
      className="system-alert"
      color="warning"
      icon={false}
      sx={{ alignItems: 'center', gap: 4, '& .MuiAlert-action': { p: 0 } }}
      action={
        selectedMessage.type !== 'version' ? (
          <IconButton
            name="Close alert"
            color="inherit"
            onClick={handleCloseMessage}
            size="small"
          ><CloseIcon fontSize="inherit" /></IconButton>
        ) : null
      }
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
        <Box
          dangerouslySetInnerHTML={{ __html: selectedMessage.message }}
          sx={{ '& a': { color: 'inherit' } }}
        />
        { renderActionButton() }
      </Box>
    </Alert>
  )
}

export default SystemNotifications;
